module.exports = __webpack_public_path__ + "img/quickbook.8f3886a0.png";